import { buildCustomTypeFilePath } from "./buildCustomTypeFilePath.js";
import { readProjectFile } from "./readProjectFile.js";
async function readCustomTypeFile(args) {
  const filePath = buildCustomTypeFilePath(args);
  return await readProjectFile({
    filename: filePath,
    encoding: args.encoding,
    helpers: args.helpers
  });
}
export {
  readCustomTypeFile
};
//# sourceMappingURL=readCustomTypeFile.js.map
